import { ENTER, SPACE } from '@angular/cdk/keycodes';
import { Overlay } from '@angular/cdk/overlay';
import {
  AfterContentChecked, AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatDialog } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';
import { ActivatedRoute, Router } from '@angular/router';
import { BREAKPOINTS } from '@sparro/app/core/config/constants.config';
import _ from 'lodash';

import { Breakpoints, BreakpointObserver } from '@angular/cdk/layout';
import { MetaDefinition } from '@angular/platform-browser';
import { CompDetailService } from '@b2b/app/core/api/detail/detail.service';
import { SearchService } from '@b2b/core/api/search/search.service';
import { environment } from '@b2b/env/environment';
import { UserService } from '@sparro/app/core/api/user/user.service';
import { MetaService } from '@sparro/app/core/helpers/meta/meta.service';
import { Competition } from '@sparro/app/core/models/competition.model';
import { Country } from '@sparro/app/core/models/location.model';
import { Discipline, Tag } from '@sparro/app/core/models/supertag.model';
import { ReplaySubject, Subject } from 'rxjs';
import { switchMap, takeUntil } from 'rxjs/operators';
import { FilterSortDialogComponent } from '../filter-sort-dialog/filter-sort-dialog.component';

export class Type {
  name: string;
  type: string;
  title?: string;
}

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
})

export class SearchComponent implements OnInit, AfterContentChecked, AfterViewInit, OnDestroy {
  querySubscription: any;
  searchString: string;
  visible: boolean = true;
  selectable: boolean = true;
  removable: boolean = true;
  addOnBlur: boolean = true;
  isLoading: boolean = false;
  showSpinner: boolean = false;
  searchCompetitionCtrl = new FormControl();
  next: string;
  page: number = 1;
  searchResults: number = 0;
  totalCount: number = 0;
  searchTabs = [];
  @ViewChild('tabsContent') tabsContent: ElementRef;
  chosenTab: string = 'Competition';
  isAll: boolean = true;
  isPrevious: boolean = false;
  isUpcoming: boolean = false;
  isOngoingRegistration: boolean = false;
  isOngoingVoting: boolean = false;
  isOngoingEvaluation: boolean = false;
  urlSubstring: string = '';

  searching: boolean = false;
  showText: boolean = false;
  registrationStartDate: string = '';
  registrationEndDate: string = '';
  submissionStartDate: string = '';
  submissionEndDate: string = '';

  searchQuery: any = [];
  competitions: Competition[] = [];
  disciplines: Discipline[] = [];
  locations: Country[] = [];
  tags: Tag[] = [];
  hosted: any;
  filteredResults: Competition[] = [];
  editorial: boolean = false;
  orderTitle: string = null;

  show: Type[] = [
    { name: 'Hosted', type: 'hosted' },
    { name: 'Listed', type: 'listed' },
    { name: 'Combined', type: 'all' },
  ];

  order: Type[] = [
    { name: 'Alphabetical order: A-Z', type: 'title', title: 'A-Z' },
    { name: 'Alphabetical order: Z-A', type: '-title', title: 'Z-A' },
    { name: 'Launch date: Latest', type: '-created_at', title: 'Latest' },
    { name: 'Launch date: oldest', type: 'created_at', title: 'Oldest' },
    { name: 'Submission Deadline', type: 'submission_end_date', title: "submission Deadline" },
    { name: 'Shortlist announcement', type: 'shortlist_end_date', title: "Shortlist announcement" },
    { name: 'Result announcement', type: 'result_end_date', title: "Result announcement" },
  ];

  timeline: Type[] = [
    { name: 'Ongoing Registration', type: 'ongoing_registration' },
    { name: 'Ongoing Voting', type: 'ongoing_voting' },
    { name: 'Ongoing evaluation', type: 'ongoing_evaluation' },
    { name: 'Upcoming', type: 'upcoming' },
    { name: 'Closed', type: 'previous' },
    { name: 'All', type: 'all' },
  ];

  selectedDisciplines: Discipline[] = [];
  selectedLocations: Country[] = [];
  selectedTags: Tag[] = [];
  isLoadingDisciplines: boolean = false;
  isLoadingLocations: boolean = false;
  selectedTypology: any = [];
  isLoadingTypology: boolean = false;
  showScroll: boolean = false;
  selectedShowType: string;
  selectedOrder: string;
  selectedTimeline: string;

  disciplineArray: number[] = [];
  locationArray: string[] = [];
  tagArray: number[] = [];

  readonly separatorKeysCodes: number[] = [ENTER, SPACE];

  @ViewChild('input') private elementRef: ElementRef;

  public disciplineControl: FormControl = new FormControl();
  public organizationControl: FormControl = new FormControl('');
  public locationControl: FormControl = new FormControl();
  public tagControl: FormControl = new FormControl();

  public disciplineSearchControl: FormControl = new FormControl();
  public locationSearchControl: FormControl = new FormControl();
  public tagSearchControl: FormControl = new FormControl();

  public searchedDisciplines: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public searchedLocations: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public searchedTags: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);

  @ViewChild('multiSelect') multiSelect: MatSelect;
  @ViewChild('chipSection') chipList: ElementRef;

  private _onDestroy = new Subject<void>();
  registrationDateRange: string = '';
  submissionDateRange: string = '';
  selectedRegistrationDateRange: string = '';
  selectedSubmissionDateRange: string = '';
  registrationPlaceholder: string = 'Registration date';
  submissionPlaceholder: string = 'Submission date';

  constructor(
    public searchService: SearchService,
    public route: ActivatedRoute,
    public router: Router,
    public metaService: MetaService,
    private changeDetectorRef: ChangeDetectorRef,
    public dialog: MatDialog,
    public overlay: Overlay,
    public breakpointObserver: BreakpointObserver,
    public userService: UserService,
  ) {
  }

  ngOnInit(): void {
    this.initializeFiltersFromParams();
    this.searchTabs = this.userService.getSearchTabs();

    this.initCompetitionSearchControl();
    this.filterCompetitions();
    this.updateMetaInfo();
    this.getDisciplines();
    this.setParams();
    this.getLocations();
    this.getTags();
    this.searchByDiscipline();
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(): void {
    const currentPos = (document.documentElement.scrollTop || document.body.scrollTop);
    const maxPos = document.documentElement.scrollHeight;
    if (currentPos >= maxPos / 2 && (this.next) && !this.showSpinner) {
      this.showSpinner = true;
      if (this.next) {
        this.filterCompetitions(true);
      }
    }
    this.showScroll = Boolean(this.tabsContent.nativeElement.offsetWidth < this.chipList.nativeElement.offsetWidth && window.innerWidth > 960);
    this.tabsContent.nativeElement.style.overflow = window.innerWidth <= 960 ? 'scroll' : 'hidden';
  }

  initializeFiltersFromParams() {
    this.querySubscription = this.route.queryParams.subscribe(
      (params) => {
        this.searchString = params.query;
        this.selectedTimeline = params.timeline ? params.timeline : '';
        if (this.selectedTimeline) {
          this.setTimeline(this.timeline.find(timeline => timeline.type === this.selectedTimeline), true);
        }
        this.selectedOrder = params.order ? params.order : this.order[0].type;
        if (params.order) {
          this.order.filter(ord=> {
            if (params.order == ord.type) {
              this.orderTitle = ord.title;
            }
          })
        } else {
          this.orderTitle = this.order[0].title;
        }
        this.selectedShowType = params.show ? params.show : '';
        if (this.selectedShowType) {
          this.setShowType(this.show.find(showType => showType.type === this.selectedShowType), true);
        }
        if (this.searchString) {
          const tempArray = this.searchString.split(',');
          for (const item of tempArray) {
            if (!this.searchQuery.includes(item)) {
              this.searchQuery.push(item);
            }
          }
        }
        if (params.registration_date_range) {
          let tempDateRange = params.registration_date_range.split(',');
          this.registrationStartDate = tempDateRange[0];
          this.registrationEndDate = tempDateRange[1];
          if (!this.selectedRegistrationDateRange) {
            this.selectedRegistrationDateRange = 'Custom';
          } this.registrationDateRange = `${this.registrationStartDate},${this.registrationEndDate}`;
        }
        if (params.submission_date_range) {
          let tempDateRange = params.submission_date_range.split(',');
          this.submissionStartDate = tempDateRange[0];
          this.submissionEndDate = tempDateRange[1];
          if (!this.selectedSubmissionDateRange) {
            this.selectedSubmissionDateRange = 'Custom';
          } this.submissionDateRange = `${this.submissionStartDate},${this.submissionEndDate}`;
        }
        if (params.organization) {
          this.organizationControl.setValue(params.organization);
        }
        if (params.tags) {
          let tempTagArray = params.tags.split(',');
          for (let tag of tempTagArray) {
            tag = parseInt(tag, 10);
            if (tag) {
              if (!this.tagArray.includes(tag)) {
                this.tagArray.push(tag);
              }
            }
          }
        }
        if (params.locations) {
          let tempLocationArray = params.locations.split(',');
          for (let location of tempLocationArray) {
            if (location) {
              if (!this.locationArray.includes(location)) {
                this.locationArray.push(location);
              }
            }
          }
        }
        if (params.disciplines) {
          let tempDisciplineArray = params.disciplines.split(',');
          for (let discipline of tempDisciplineArray) {
            if (discipline) {
              if (!this.disciplineArray.includes(discipline)) {
                this.disciplineArray.push(discipline);
              }
            }
          }
        }
        if (params.editorial == "true"){
          this.editorial = true;
        }
      });
  }

  initCompetitionSearchControl(): void {
    this.searchCompetitionCtrl.valueChanges
      .pipe(
        switchMap(
          (value: any) => (
            this.searchService.getFilteredResults(this.page, this.searchQuery.toString(),
              this.disciplineArray.toString(), this.tagArray.toString(), this.locationArray.toString(),
              this.urlSubstring, this.selectedOrder, this.hosted, this.registrationDateRange, 
              this.submissionDateRange, this.organizationControl.value, this.editorial))
        )
      ).subscribe(
        (response: any) => {
          this.totalCount = response.count;
          this.searchResults += response.results.length;
          this.filteredResults = [...this.filteredResults, ...response.results];
          if (response.next) {
            this.next = response.next;
            const num = this.next.match(/page=(\d+)/)[1];
            this.page = parseInt(num);
          } else {
            this.next = null;
          }
          this.isLoading = false;
          this.showSpinner = false;
        }, (err) => {
          console.log(err);
        });
  }

  updateMetaInfo(): void {
    const metaInfo: MetaDefinition[] = [
      { name: 'title', content: 'Search design competitions | UNI' },
      { name: 'description', content: `Find real-world design competitions from all over the world. Participate
        and present innovative design solution to some of the most challenging problems in the world.` }
    ];
    metaInfo.forEach(meta => {
      this.metaService.updateMetaInfo(meta);
    });
    this.metaService.updateMeta(metaInfo);
    this.metaService.updateTitle('Search design competitions | UNI');
    this.metaService.createCanonicalURL();
  }

  ngAfterContentChecked(): void {
    this.changeDetectorRef.detectChanges();
  }

  ngAfterViewInit(): void {
    // if (this.elementRef.nativeElement) {
    //   this.elementRef.nativeElement.focus();
    // }
    this.changeDetectorRef.detectChanges();
    this.checkSearchDisciplineParam();
  }

  ngOnDestroy(): void {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  checkSearchDisciplineParam(): void {
    const discipline = this.searchService.getSearchDiscipline();
    if (discipline) {
      this.setDiscipline(discipline);
    }
  }

  searchByDiscipline(): void {
    this.searchService.searchByDisciplineInitialized.subscribe(
      (initialized: boolean) => {
        if (initialized) {
          this.searchService.searchedDisciplines.subscribe(
            (response: any) => {
              response.filter((discipline) => {
                this.setDiscipline(discipline);
              });
            });
        }
      });
  }

  getLocations(): void {
    this.isLoadingLocations = true;
    this.searchService.getFilteredCountries().subscribe(
      (response: any) => {
        this.locations = _.orderBy(response, 'name', 'asc');
        this.searchedLocations.next(this.locations.slice());
        this.isLoadingLocations = false;
        for (const location of this.locationArray) {
          let locationObj = this.locations.find(obj => obj.iso_code == location);
          if (locationObj) {
            console.log(this.selectedLocations.find(obj => obj.iso_code == locationObj.iso_code));
            if (!this.selectedLocations.find(obj => obj.iso_code == locationObj.iso_code)) {
              this.selectedLocations.push(locationObj);
              this.locationControl.setValue(this.selectedLocations);
            }
          }
          else {
            let index = this.locationArray.indexOf(location);
            this.locationArray.splice(index, 1);
          }
        }
        this.locationSearchControl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this._filterLocations();
          });
      }, (err) => {
        console.log(err);
      });
  }

  getDisciplines(): void {
    this.isLoadingDisciplines = true;
    this.searchService.getFilteredDisciplines().subscribe(
      (response: Discipline[]) => {
        this.disciplines = _.orderBy(response, 'name', 'asc');
        this.searchedDisciplines.next(this.disciplines.slice());
        this.isLoadingDisciplines = false;
        for (const discipline of this.disciplineArray) {
          let disciplineObj = this.disciplines.find(obj => obj.id == discipline);
          if (disciplineObj) {
            console.log(this.selectedDisciplines.find(obj => obj.id == disciplineObj.id));
            if (!this.selectedDisciplines.find(obj => obj.id == disciplineObj.id)) {
              this.selectedDisciplines.push(disciplineObj);
              this.disciplineControl.setValue(this.selectedDisciplines);
            }
          }
          else {
            let index = this.disciplineArray.indexOf(discipline);
            this.disciplineArray.splice(index, 1);
          }
        }
        this.disciplineSearchControl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this._filterDisciplines();
          });
      }, (err) => {
        console.log(err);
      });
  }

  getTags(): void {
    this.isLoadingTypology = true;
    this.searchService.getFilteredTags().subscribe(
      (response: Tag[]) => {
        this.tags = _.orderBy(response, 'name', 'asc');
        this.searchedTags.next(this.tags.slice());
        this.isLoadingTypology = false;
        for (const tag of this.tagArray) {
          let tagObj = this.tags.find(obj => obj.id == tag);
          if (tagObj) {
            console.log(this.selectedTags.find(obj => obj.id == tagObj.id));
            if (!this.selectedTags.find(obj => obj.id == tagObj.id)) {
              this.selectedTags.push(tagObj);
              this.tagControl.setValue(this.selectedTags);
            }
          }
          else {
            let index = this.tagArray.indexOf(tag);
            this.tagArray.splice(index, 1);
          }
        }
        this.tagSearchControl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this._filterTags();
          });
      }, (err) => {
        console.log(err);
      });
  }

  _filterDisciplines(): void {
    if (!this.disciplines) {
      return;
    }
    let search = this.disciplineSearchControl.value;
    if (!search) {
      this.searchedDisciplines.next(this.disciplines.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.searchedDisciplines.next(
      this.disciplines.filter(
        discipline => discipline.name.toLowerCase().indexOf(search) > -1)
    );
  }

  _filterLocations(): void {
    if (!this.locations) {
      return;
    }
    let search = this.locationSearchControl.value;
    if (!search) {
      this.searchedLocations.next(this.locations.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.searchedLocations.next(
      this.locations.filter(
        location => location.name.toLowerCase().indexOf(search) > -1)
    );
  }

  _filterTags(): void {
    if (!this.tags) {
      return;
    }
    let search = this.tagSearchControl.value;
    if (!search) {
      this.searchedTags.next(this.tags.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.searchedTags.next(
      this.tags.filter(
        tag => tag.name.toLowerCase().indexOf(search) > -1)
    );
  }

  reset(type: string): void {
    if (type === 'disciplines') {
      this.selectedDisciplines = [];
      this.disciplineArray = [];
      this.disciplineControl.setValue(null);

    } else if (type === 'tags') {
      this.selectedTags = [];
      this.tagArray = [];
      this.tagControl.setValue(null);

    } else if (type === 'location') {
      this.selectedLocations = [];
      this.locationControl.setValue(null);

    } else if (type === 'all') {
      this.organizationControl.reset('');
      this.selectedDisciplines = [];
      this.disciplineArray = [];
      this.disciplineControl.setValue(null);
      this.selectedLocations = [];
      this.locationArray = [];
      this.locationControl.setValue(null);
      this.selectedTags = [];
      this.tagArray = [];
      this.tagControl.setValue(null);
      this.isPrevious = this.isUpcoming = this.isOngoingEvaluation = 
        this.isOngoingRegistration = this.isOngoingVoting = false;
      this.isAll = true;
      this.selectedOrder = this.order[0].type;
      this.orderTitle = this.order[0].title,
      this.hosted = null;
      this.selectedShowType = this.show[0].type;
      this.selectedTimeline = this.timeline[0].type;
      this.registrationDateRange = '';
      this.submissionDateRange = '';
      this.selectedRegistrationDateRange = '';
      this.selectedSubmissionDateRange = '';
      this.registrationStartDate = '';
      this.registrationEndDate = '';
      this.submissionStartDate = '';
      this.submissionEndDate = '';
    }
    this.resetPage();
    this.filterCompetitions();
  }

  resetPage(): void {
    this.page = 1;
    this.filteredResults = [];
  }

  setLocation(location: Country): void {
    if (!this.locationArray.includes(location.iso_code)) {
      this.selectedLocations.push(location);
      this.locationArray.push(location.iso_code);
    }
    this.locationControl.setValue(this.selectedLocations);
    this.resetPage();
    this.setParams();
    this.filterCompetitions();
  }

  setTag(tag: Tag): void {
    if (!this.tagArray.includes(tag.id)) {
      this.selectedTags.push(tag);
      this.tagArray.push(tag.id);
    }
    this.tagControl.setValue(this.selectedTags);
    this.resetPage();
    this.setParams();
    this.filterCompetitions();
  }

  setTimeline(timeline, initial: boolean = false) {
    if (timeline) {
      this.selectedTimeline = timeline.type;
      if (timeline.type == 'previous') {
        this.isPrevious = true;
        this.isUpcoming = false;
        this.isAll = false;
        this.isOngoingRegistration = false;
        this.isOngoingVoting = false;
        this.isOngoingEvaluation = false;
      } else if (timeline.type == 'upcoming') {
        this.isUpcoming = true;
        this.isPrevious = false;
        this.isAll = false;
        this.isOngoingRegistration = false;
        this.isOngoingVoting = false;
        this.isOngoingEvaluation = false;
      } else if (timeline.type == 'all') {
        this.isAll = true;
        this.isPrevious = false;
        this.isUpcoming = false;
        this.isOngoingRegistration = false;
        this.isOngoingVoting = false;
        this.isOngoingEvaluation = false;
      } else if (timeline.type == 'ongoing_registration') {
        this.isPrevious = false;
        this.isUpcoming = false;
        this.isAll = false;
        this.isOngoingRegistration = true;
        this.isOngoingVoting = false;
        this.isOngoingEvaluation = false;
      } else if (timeline.type == 'ongoing_voting') {
        this.isPrevious = false;
        this.isUpcoming = false;
        this.isAll = false;
        this.isOngoingRegistration = false;
        this.isOngoingVoting = true;
        this.isOngoingEvaluation = false;
      } else if (timeline.type == 'ongoing_evaluation') {
        this.isPrevious = false;
        this.isUpcoming = false;
        this.isAll = false;
        this.isOngoingRegistration = false;
        this.isOngoingVoting = false;
        this.isOngoingEvaluation = true;
      }
      if (!initial) {
        this.resetPage();
        this.setParams();
        this.filterCompetitions();
      }
    }
  }

  setShowType(show: Type, initial: boolean = false) {
    if (show) {
      this.selectedShowType = show.type;
      if (show.type === 'all') {
        this.hosted = null;
      } else if (show.type === 'hosted') {
        this.hosted = true;
      } else if (show.type === 'listed') {
        this.hosted = false;
      }
      if (!initial) {
        this.resetPage();
        this.setParams();
        this.filterCompetitions();
      }
    }
  }

  setEditorial(event){
    this.editorial = event.checked;
    this.resetPage();
    this.setParams();
    this.filterCompetitions();
  }

  setOrderType(order: Type): void {
    this.selectedOrder = order.type;
    this.orderTitle = order.title;
    this.resetPage();
    this.setParams();
    this.filterCompetitions();
  }

  setDiscipline(discipline: Discipline): void {
    if (!this.disciplineArray.includes(discipline.id)) {
      this.disciplineArray.push(discipline.id);
      this.selectedDisciplines.push(discipline);
    }
    this.disciplineControl.setValue(this.selectedDisciplines);
    this.resetPage();
    this.setParams();
    this.filterCompetitions();
  }

  removeDiscipline(discipline: Discipline) {
    this.selectedDisciplines = this.selectedDisciplines.filter((disciplineObj, value) => {
      return disciplineObj.id !== discipline.id;
    });
    const index = this.disciplineArray.indexOf(discipline.id);
    if (index >= 0) {
      this.disciplineArray.splice(index, 1);
    }
    if (this.selectedDisciplines.length > 0) {
      this.disciplineControl.setValue(this.selectedDisciplines);
    } else {
      this.disciplineControl.setValue(null);
    }
    this.resetPage();
    this.setParams();
    this.filterCompetitions();
  }

  removeLocation(location: Country) {
    this.selectedLocations = this.selectedLocations.filter((locationObj, value) => {
      return locationObj.iso_code !== location.iso_code;
    });
    const index = this.locationArray.indexOf(location.iso_code);
    if (index >= 0) {
      this.locationArray.splice(index, 1);
    }
    if (this.selectedLocations.length > 0) {
      this.locationControl.setValue(this.selectedLocations);
    } else {
      this.locationControl.setValue(null);
    }
    this.resetPage();
    this.setParams();
    this.filterCompetitions();
  }

  removeTag(tag: Tag) {
    this.selectedTags = this.selectedTags.filter((tagObj, value) => {
      return tagObj.id !== tag.id;
    });
    const index = this.tagArray.indexOf(tag.id);
    if (index >= 0) {
      this.tagArray.splice(index, 1);
    }
    if (this.selectedTags.length > 0) {
      this.tagControl.setValue(this.selectedTags);
    } else {
      this.tagControl.setValue(null);
    }
    this.resetPage();
    this.setParams();
    this.filterCompetitions();
  }

  removeRegistrationDateRange(): void {
    this.registrationDateRange = '';
    this.selectedRegistrationDateRange = '';
    this.registrationStartDate = '';
    this.registrationEndDate = '';
    this.resetPage();
    this.setParams();
    this.filterCompetitions();
  }

  removeSubmissionDateRange(): void {
    this.submissionDateRange = '';
    this.selectedSubmissionDateRange = '';
    this.submissionStartDate = '';
    this.submissionEndDate = '';
    this.resetPage();
    this.setParams();
    this.filterCompetitions();
  }

  addSearchText(text): void {
    if ((text || '').trim()) {
      this.searchQuery.push(text.trim().toLowerCase());
      this.resetPage();
      this.setParams();
      this.filterCompetitions();
    }
  }

  removeSearchText(result: any): void {
    const index = this.searchQuery.indexOf(result);

    if (index >= 0) {
      this.searchQuery.splice(index, 1);
    }
    this.resetPage();
    this.setParams();
    this.filterCompetitions();
  }

  filterCompetitions(isLoadMore?: boolean): void {
    if (isLoadMore) {
    }
    else {
      this.searchResults = 0;
    }
    if (!this.showSpinner) {
      this.isLoading = true;
    }
    if (this.isPrevious) {
      this.urlSubstring = 'inactive';
    } else if (this.isUpcoming) {
      this.urlSubstring = 'upcoming';
    } else if (this.isOngoingEvaluation) {
      this.urlSubstring = 'ongoing_evaluation';
    } else if (this.isOngoingRegistration) {
      this.urlSubstring = 'ongoing_registration';
    } else if (this.isOngoingVoting) {
      this.urlSubstring = 'ongoing_voting';
    } else {
      this.urlSubstring = '';
    }
    this.searchCompetitionCtrl.reset();
  }


  setParams(): void {
    this.router.navigate([], {
      queryParams: {
        query: this.searchQuery.toString(),
        timeline: this.selectedTimeline,
        order: this.selectedOrder,
        show: this.selectedShowType,
        organization: this.organizationControl.value,
        tags: this.tagArray.toString(),
        disciplines: this.disciplineArray.toString(),
        locations: this.locationArray.toString(),
        registration_date_range: this.registrationDateRange,
        submission_date_range: this.submissionDateRange,
        editorial: this.editorial,
      },
      queryParamsHandling: 'merge',
    });
  }

  openFilterDialog() {
    this.openFilterSortDialog(true);
  }

  openSortDialog() {
    this.openFilterSortDialog(false, true);
  }

  openFilterSortDialog(filter: boolean = false, sort: boolean = false): void {
    const dialogRef = this.dialog.open(FilterSortDialogComponent, {
      maxHeight: '80vh',
      maxWidth: '100vw',
      width: '100vw',
      panelClass: 'custom-search-dialogbox',
      data: {
        filter: filter,
        sort: sort,
        order: this.order,
        show: this.show,
        timeline: this.timeline,
        disciplines: this.disciplines,
        locations: this.locations,
        tags: this.tags,
        selectedOrder: this.selectedOrder,
        selectedShowType: this.selectedShowType,
        selectedTimeline: this.selectedTimeline,
        selectedLocations: this.selectedLocations,
        selectedDisciplines: this.selectedDisciplines,
        selectedTags: this.selectedTags,
        registrationDateRange: this.registrationDateRange,
        submissionDateRange: this.submissionDateRange,
        selectedRegistrationDateRange: this.selectedRegistrationDateRange,
        selectedSubmissionDateRange: this.selectedSubmissionDateRange,
        registrationStartDate: this.registrationStartDate,
        registrationEndDate: this.registrationEndDate,
        submissionStartDate: this.submissionStartDate,
        submissionEndDate: this.submissionEndDate,
        organizationControl: this.organizationControl.value,
        isAll: this.isAll,
        isPrevious: this.isPrevious,
        isUpcoming: this.isUpcoming,
        locationArray: this.locationArray,
        disciplineArray: this.disciplineArray,
        tagArray: this.tagArray,
        editorial: this.editorial
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.selectedDisciplines = result.selectedDisciplines;
        this.selectedLocations = result.selectedLocations;
        this.selectedTags = result.selectedTags;
        this.selectedTimeline = result.selectedTimeline;
        this.selectedOrder = result.selectedOrder;
        this.selectedShowType = result.selectedShowType;
        this.registrationDateRange = result.registrationDateRange;
        this.submissionDateRange = result.submissionDateRange;
        this.selectedRegistrationDateRange = result.selectedRegistrationDateRange;
        this.selectedSubmissionDateRange = result.selectedSubmissionDateRange;
        this.registrationStartDate = result.registrationStartDate;
        this.registrationEndDate = result.registrationEndDate;
        this.submissionStartDate = result.submissionStartDate;
        this.submissionEndDate = result.submissionEndDate;
        this.organizationControl.setValue(result.organizationControl);
        this.isAll = result.isAll;
        this.isPrevious = result.isPrevious;
        this.isUpcoming = result.isUpcoming;
        this.disciplineArray = result.disciplineArray;
        this.locationArray = result.locationArray;
        this.tagArray = result.tagArray;
        this.editorial = result.editorial;
        this.setParams();
        this.resetPage();
        this.filterCompetitions();
      }
    });
  }

  goToSearch(appUrl: string): void {
    if (appUrl !== 'competitionUrl') {
      const query = this.searchQuery.toString();
      if (this.searchQuery.length > 0) {
        window.location.href = `${environment[appUrl]}search?query=${query}`;
      } else {
        window.location.href = `${environment[appUrl]}search`;
      }
    }
  }


  scroll(direction: string): void {
    if (direction === 'left') {
      this.tabsContent.nativeElement.scrollLeft -= 150;
    }
    else {
      this.tabsContent.nativeElement.scrollLeft += 150;
    }
  }

  setDateRange(range: any): void {
    if (range.placeholder === 'Submission date') {
      this.submissionDateRange = range.startDate + ',' + range.endDate;
      this.selectedSubmissionDateRange = range.selectedRange;
    }
    if (range.placeholder === 'Registration date') {
      this.registrationDateRange = range.startDate + ',' + range.endDate;
      this.selectedRegistrationDateRange = range.selectedRange;
    }
    this.resetPage();
    this.setParams();
    this.filterCompetitions();
  }

  setOrganization(): void {
    this.resetPage();
    this.setParams();
    this.filterCompetitions();
  }

  tabSelected(tab): void {
    this.chosenTab = tab.name;
    // This is added just for the scenario when the user changes screen size.
  }
}
